import FetchByObjectConfig from '../Helpers/FetchByObjectConfig';

export const validateCaptchaRequest = (body) => {
    const config = {
        path: 'captcha',
        method: 'POST',
        body,
    };
    return FetchByObjectConfig(config);
}